import { Group } from 'features/Group'
import { AppPage } from 'interfaces'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { useUser } from 'state'

const GroupSearchMainSection = dynamic(
  () => import('../components/GroupSearchMainSection')
)

const GroupSearch: AppPage = () => {
  const user = useUser()
  const [doSearch, setDoSearch] = useState(false)
  const [groups, setGroups] = useState<Group[]>([])

  const router = useRouter()

  useEffect(() => {
    // if (
    //   user &&
    //   user?.user_group_details &&
    //   user?.type !== 'admin' &&
    //   !user.batch_leader_details
    // ) {
    //   // check this as of now there are multiple groups which one useer can join so on which group do we have to redirect!
    //   router.replace(`/groups/${user.user_group_details[0].slug}`)
    // } else
    if (user && user.batch_leader_details && user?.type !== 'admin') {
      setGroups(user.batch_leader_details)
    } else {
      setDoSearch(true)
    }
  }, [router, user])

  return (
    <GroupSearchMainSection
      doSearch={doSearch}
      groups={groups}
      setGroups={setGroups}
    />
  )
}

GroupSearch.auth = {
  shouldBeLoggedIn: true
}

GroupSearch.layout = {
  hideFooter: true
}

GroupSearch.seo = {
  title: 'Groups | Devsnest'
}

export default GroupSearch
